import { Button } from "@/components/ui/button";
import { t } from "@workspace/strings/web";

type ObservabilityFallbackProps = {
  error: unknown;
  componentStack: string;
  eventId: string;
  resetError: () => void;
};

export function ObservabilityFallback({
  resetError,
}: ObservabilityFallbackProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center gap-4 bg-background px-4 text-center">
      <h1 className="text-xl font-semibold text-foreground">
        {t("common.status.somethingWentWrong")}
      </h1>
      <p className="max-w-md text-sm text-muted-foreground">
        {t("webMisc.errorFallback.description")}
      </p>
      <div className="flex gap-2">
        <Button onClick={() => resetError()}>{t("webMisc.action.tryAgain")}</Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          {t("common.action.refresh")}
        </Button>
      </div>
    </div>
  );
}
